import Chart from 'chartjs';
import React, { Component, Fragment } from 'react';
import { criteriaStore } from 'stores/CriteriaStore';

const dataConfig = {
  backgroundColor: 'rgba(255, 102, 102, 0.4)',
  borderColor: 'rgba(255, 102, 102, 0.4)',
  pointBackgroundColor: 'rgba(255, 102, 102, 1)',
  pointBorderColor: 'rgba(255, 102, 102, 1)',
  showLine: true,
};

export default class ChartComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'spectra',
    };
  }

  componentDidMount() {
    // Need to initialize Materializecss tabs
    $('ul#seismicChartTabs.tabs').tabs();

    const { title, labels, data } = this.props;
    let chart;

    // console.group(title);
    // console.log('Labels', labels);
    // console.log('Data', data);
    // console.groupEnd();

    if (data.length > 0) {
      const ctx = document.getElementById('chart' + title).getContext('2d');
      window.Chart.defaults.global.legend.display = false;

      chart = new Chart(ctx, {
        type: 'scatter',
        data: {
          datasets: [
            {
              data: data,
              ...dataConfig,
            },
          ],
        },
      });
    }
  }

  createCSV() {
    const { data } = this.props;
    const filename = `${this.props.title}-${moment().format('YMMDD')}.csv`;
    let csv = 'T(s),Sa(g)\n';
    const mimetype = 'text/csv;encoding:utf-8';
    data.map((point) => {
      const { x, y } = point;
      csv += `${x},${y}\n`;
    });

    const el = document.getElementById('csv-download');
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(
        new Blob([csv], {
          type: mimetype,
        }),
        filename
      );
    } else {
      el.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      el.target = '_blank';
      el.download = filename;
      el.click();
    }
  }

  handleTab(evt) {
    this.setState({ activeTab: evt.currentTarget.id });
  }

  createTable() {
    const { data } = this.props;
    return data.map((point, idx) => {
      const { x, y } = point;
      return (
        <tr key={idx}>
          <td>{x}</td>
          <td>{y}</td>
        </tr>
      );
    });
  }

  checkIfMCER(title) {
    if (typeof title === 'string' && title.includes('MCER')) {
      let pos = title.indexOf('MCER');
      let bef = title.substring(0, pos);
      let aft = title.substring(pos + 5).trim(); //3 derives from length of MCER and plus 1 to start after and remove spaces
      return (
        <span>
          {bef} MCE<sub>R</sub>
          {'\u00A0'}
          {aft}
        </span>
      );
    } else {
      return title;
    }
  }

  render() {
    const { title, data } = this.props;
    const { activeTab } = this.state;
    const standard = criteriaStore.getState().standardsVersion;
    const newTitle = this.checkIfMCER(title);

    return (
      <div className='popup-chart-container'>
        <div className='row'>
          <h6>{newTitle}</h6>
          {data.length > 0 ? (
            <div className='col s12'>
              <ul id='seismicChartTabs' className='tabs'>
                <li
                  id='spectra'
                  onClick={this.handleTab.bind(this)}
                  className={`tab col tab-selector pointer ${activeTab === 'spectra' ? 'active' : ''}`}
                >
                  <a>{standard === '7-22' ? 'Graph' : 'Spectra'}</a>
                </li>
                <li
                  id='table'
                  onClick={this.handleTab.bind(this)}
                  className={`tab col tab-selector pointer ${activeTab === 'table' ? 'active' : ''}`}
                >
                  <a>Table</a>
                </li>
                <li id='csv' onClick={this.createCSV.bind(this)} className='tab col tab-selector pointer'>
                  <a>CSV</a>
                </li>
              </ul>
            </div>
          ) : (
            <p>Vertical ground motion data has not yet been made available by USGS.</p>
          )}
        </div>
        {data.length > 0 && (
          <div>
            <div className={`${activeTab === 'spectra' ? '' : 'hidden'}`}>
              <canvas id={'chart' + this.props.title} width='420' height='150'></canvas>
              <div className='flex flex-justify-center'>
                <span>
                  S<sub>a</sub>(g) vs T(s)
                </span>
              </div>
            </div>
            <div className={`details-popup__table ${activeTab === 'table' ? '' : 'hidden'}`}>
              <table className='striped centered'>
                <thead>
                  <tr>
                    <th>T(s)</th>
                    <th>
                      S<sub>a</sub>(g)
                    </th>
                  </tr>
                </thead>
                <tbody>{this.createTable()}</tbody>
              </table>
            </div>
            <div className={`${activeTab === 'csv' ? '' : 'hidden'}`}></div>
          </div>
        )}
      </div>
    );
  }
}
